<div class="eod-input" [ngClass]="{'disabled':to.disabled}" (click)="clickAction()">
    <!-- `label` is optional: callers that only set `placeholder` keep using it for both,
         which is how every screen before Add/Edit Category was written. -->
    <label for="example-text-input" class="form-label">{{ field.templateOptions.label || field.templateOptions.placeholder }}@if (field.templateOptions.required){<span class="required-field">*</span>}</label>
    <ng-select id="{{ 'select' + fieldKey }}" class="select-dropdown select-dropdown--md auditTrailDropdown"
        [items]="to.options" bindLabel="value" bindValue="id" [groupBy]="to.groupBy" [clearable]="false" [formControl]="formControl" [selectOnTab]="true"
        placeholder="{{ field.templateOptions.placeholder }}"
        notFoundText="{{ 'no_data_available' | translate: param }}" (change)="onValueChange()"
        (keypress)="omitSpecialChar($event)">

        <ng-template ng-option-tmp let-item="item" let-index="index">
            @if(!item.isLink){<div class="custom-dropdown" style="padding: 10px 0px !important;"
                [ngStyle]="{'opacity': item.disabled ? .7 : 1}">
                <p class="font-weight-bold employee-role-option">{{ item.value }}</p>
                <p class="employee-role-option">{{ item.description }}</p>
            </div>}
            @if(item.isLink){<span class="linkOption dropdownLink">
                <a class="float-left d-block linkOption dropdownLink">
                    {{ item.value }}
                </a>
            </span>}
        </ng-template>

    </ng-select>

    @if(formControl.errors && formControl.errors.required && isFormSubmitted){<p class="text-error f-11">
        {{ "label_Required" | translate: param }}
    </p>}

    @if(field.templateOptions.customErrors && field.templateOptions.customErrors.length > 0 && isFormSubmitted){<span>
        @for(error of field.templateOptions.customErrors; track error; let i = $index){<p class="text-error f-11">
            {{error}}
        </p>}
    </span>}

    @if(field.templateOptions.alertNote){<p class="text-error f-11">
        {{ field.templateOptions.alertNote }}
    </p>}

    <span class="rightTinyText mt-1 f-11" *ngIf="to.attributes && to.attributes.isTinyTextDisplay==1"
        (click)="onTinyClick()">
        <a>{{to.attributes.tinyText}}</a>
    </span>

    @if(field.templateOptions.note && field.templateOptions.note){<p class="text-left f-11" [innerHTML]="sanitizerHtml(field.templateOptions.note)">
    </p>}

    @if(field.templateOptions.supportingNote){<p [ngClass]="{ 'text-left f-11 font-weight-bold cursor-pointer text-underline text-logo-blue' : linkType, 
                            'text-left f-11 font-weight-bold cursor-pointer' : linkType == false }"
        (click)="fnOpenPanel()">
        <span class="cursor-pointer" [innerHTML]="sanitizerHtml(field.templateOptions.supportingNote)"></span>
    </p>}

</div>

@if(field.templateOptions.supportingLink){<p [ngClass]="{ 'text-left f-11 font-weight-bold cursor-pointer text-underline text-logo-blue' : linkType, 
                            'text-left f-11 font-weight-bold cursor-pointer' : linkType == false }"
    (click)="fnOpenPanel()">
    <span class="cursor-pointer" [innerHTML]="sanitizerHtml(field.templateOptions.supportingLink)"></span>
</p>}

@if(field.templateOptions.supportingLinks){
<p class="text-secondary f-11 mt-1">
    {{ field.templateOptions.supportingLinksPrefix }}
    @for(link of field.templateOptions.supportingLinks; track link; let i = $index){
        @if(i > 0){ or }
        <span class="text-logo-blue text-underline cursor-pointer" (click)="fnOpenSupportingLink(link)">{{link.text}}</span>
    }
</p>}